import { Tooltip } from 'antd';
import React from 'react';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';

export class TitleReviewBursts extends React.Component {
	render() {
		const isMobile = this.props.isMobile();
		const { reviews, rating } = this.props;
		return (
			<React.Fragment>
				{reviews > 0 && (
					<React.Fragment>
						<Tooltip
							title={
								<span style={{ fontSize: '11px' }}>
									# of Reviews
								</span>
							}
							placement="bottom">
							<div
								className={`burst-12 ${
									!isMobile
										? 'review-count-badge'
										: 'review-count-badge-mobile'
								}`}>
								<div>{reviews}</div>
							</div>
						</Tooltip>
						<Tooltip
							title={
								<span style={{ fontSize: '11px' }}>
									Avg Rating (1-10)
								</span>
							}
							placement="bottom">
							<div
								className={`burst-12 ${
									!isMobile
										? 'review-rating-badge'
										: 'review-rating-badge-mobile'
								}`}>
								<div>
									<b>{rating * 1 < 10 ? rating : parseInt(rating)}</b>
								</div>
							</div>
						</Tooltip>
					</React.Fragment>
				)}
			</React.Fragment>
		);
	}
}

export default withIsMobile(TitleReviewBursts);
